"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _ThumbnailUrlConfig = _interopRequireDefault(require("customer-data-email/schema/attachments/ThumbnailUrlConfig"));

var fileOptions = {
  query: {
    hidden: true
  }
};
var emptyValidators = {
  file: function file() {
    return false;
  },
  all: function all() {
    return (0, _immutable.Seq)();
  }
};

var _default = (0, _immutable.Record)({
  GenericPluginGroup: null,
  AttachmentPlugin: null,
  FileManagerAttachmentPlugin: null,
  fileOptions: fileOptions,
  thumbnailUrlConfig: (0, _ThumbnailUrlConfig.default)(),
  validators: emptyValidators,
  onOpenPopover: function onOpenPopover() {}
}, 'InteractionWithValidatedAttachmentsComponentConfig');

exports.default = _default;
module.exports = exports.default;